import { apolloClient } from "../../../src/graphql/apolloClient";
import { GROWTH_PROJECTIONS_BULK_QUERY } from "../../../src/pages/rankings/growthProjections/growthProjectionsPressRelease/useGrowthProjectionsData";
import { CPProductClass } from "../../../src/types/countryProfileEnums";
import RankingsLayout from "../../../src/pages/rankings/RankingsLayout";
import { buildMeta } from "../../routeMeta";

export async function clientLoader() {
  await apolloClient.query({
    query: GROWTH_PROJECTIONS_BULK_QUERY,
    variables: { productClass: CPProductClass.HS12 },
    fetchPolicy: "cache-first",
  });
  return null;
}
clientLoader.hydrate = false as const;

export function meta(args) {
  return buildMeta(
    {
      title: "Growth Projections Data — The Atlas of Economic Complexity",
      description:
        "Country-level growth projections data from the Harvard Growth Lab.",
      ogImage: "share_growth_projections.png",
    },
    args,
  );
}

export default RankingsLayout;
